import { render, staticRenderFns } from "./SliderCard.vue?vue&type=template&id=5a4f98ae&"
import script from "./SliderCard.vue?vue&type=script&lang=js&"
export * from "./SliderCard.vue?vue&type=script&lang=js&"
import style0 from "./SliderCard.vue?vue&type=style&index=0&id=5a4f98ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports